import styled from "@emotion/styled";

export const HeroContainer = styled.div({
    // layout
    display: 'grid',
    justifyContent: 'center',
    alignItems: 'center',
})